import * as React from "react";
import { memo } from "react";
const SvgDot = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 9, viewBox: "0 0 10 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 5, cy: 4.5, r: 4, fill: "white", stroke: "#88A4BE" }));
const Memo = memo(SvgDot);
export default Memo;
